export default __webpack_public_path__ + "static/media/ministry-of-health-prevention-seeklogo.com.43d5aba7.svg";